import React from 'react';
import { arrayOf, objectOf, shape, string, func } from 'prop-types';
import { connect } from 'unistore/react';
import map from 'lodash/fp/map';
import { actions, selectedAddOnProps } from '../store/PlanStore';
import ProductDisplay, {
  productDisplayProductPropTypes,
} from 'common/components/shop/ProductDisplay';
import ShopButton from 'common/components/ShopButton';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import {
  sortProductOfferingsByPrice,
  getOfferingPrice,
} from '../../product/util/offerings';

function AddOnsPicker({
  productDisplays,
  selectedAddOns,
  updateAddOnQuantity,
}) {
  return productDisplays.map(({ heading, imagePosition, lede, products }) => {
    return (
      <ProductDisplay
        key={heading}
        heading={heading}
        imagePosition={imagePosition}
        learnMoreText={
          <TranslatedMessage id="page.shop.product_display.learn_more" />
        }
        lede={lede}
        products={products}
        renderCallToActionButtons={product => {
          const sortedOfferings = sortProductOfferingsByPrice(product);

          return map(offering => {
            const isInCart = !!selectedAddOns[offering.id];
            const isCommitmentReward = !!offering.commitmentReward;
            const showPrice = sortedOfferings.length > 1;
            const price = getOfferingPrice(product, offering);

            const onClick = () =>
              updateAddOnQuantity({
                product,
                offering,
                quantity: isInCart ? 0 : 1,
              });

            let buttonColor = undefined;

            if (isCommitmentReward) {
              buttonColor = 'auto-ship';
            } else if (isInCart) {
              buttonColor = 'light';
            }

            return (
              <ShopButton
                key={offering.id}
                color={buttonColor}
                onClick={onClick}
                removeItem={isInCart}
              >
                <TranslatedMessage
                  id={
                    isInCart
                      ? 'remove_item'
                      : isCommitmentReward
                      ? 'cart.subscription_commit_button.get_it_with_autoship'
                      : 'cart.add_to_cart_button.add_to_cart'
                  }
                />
                {showPrice && isFinite(price) ? (
                  <>
                    {' - '}
                    <PriceSpan amount={price} />
                  </>
                ) : null}
              </ShopButton>
            );
          })(sortedOfferings);
        }}
      />
    );
  });
}

AddOnsPicker.propTypes = {
  productDisplays: arrayOf(
    shape({
      heading: string,
      imagePosition: string,
      lede: string,
      products: productDisplayProductPropTypes.isRequired,
    })
  ),
  selectedAddOns: objectOf(selectedAddOnProps),
  updateAddOnQuantity: func.isRequired,
};

export default connect(
  ['selectedAddOns'],
  actions
)(AddOnsPicker);
